module.exports = __webpack_public_path__ + "static/media/85450022-m5B0wSgs.630fa0da.JPG";